import {
  AlertCircle,
  Bank,
  Check,
  CoinsHand,
  Copy06,
  ArrowCircleBrokenUpRight,
  ArrowNarrowLeft,
  ArrowNarrowRight,
  Building01,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  BarChart01,
  FilterFunnel01,
  Calendar,
  CalendarPlus01,
  ChevronSelectorVertical,
  Hash01,
  CheckCircle,
  CheckCircleBroken,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Clock,
  CoinsSwap01,
  BankNote01,
  CreditCardCheck,
  CreditCardDown,
  CreditCardEdit,
  CreditCardMinus,
  CreditCardRefresh,
  CreditCardUp,
  RefreshCw05,
  CreditCardX,
  CurrencyDollarCircle,
  DotsHorizontal,
  DotsVertical,
  Download01,
  DownloadCloud02,
  Edit01,
  Eye,
  File01,
  File04,
  File06,
  Globe01,
  Grid01,
  HelpCircle,
  Home01,
  Inbox01,
  LineChartUp02,
  Link02,
  Link05,
  LinkExternal02,
  LogOut01,
  Mail01,
  Passport,
  Pencil01,
  PieChart01,
  PlusCircle,
  ReceiptCheck,
  Ticket01,
  SwitchHorizontal01,
  Tool01,
  Save01,
  SearchLg,
  SearchMd,
  Send01,
  Settings01,
  Shield01,
  ShieldTick,
  Trash01,
  UploadCloud02,
  Phone01,
  User01,
  UserX01,
  UserPlus01,
  Users01,
  Users02,
  Table,
  Users03,
  Wallet03,
  XCircle,
  XClose,
  MarkerPin03,
  MarkerPin06,
  UserCheck01,
  Star06,
  Lock01,
  Building02,
  Building04,
  Building05,
  Building08,
  Car01,
  Home02,
  Map02,
  Rows03,
  Menu01,
  Route,
  BellRinging01,
  MessageSquare01,
  Zap
} from '@untitledui/icons';
import {
  Activity,
  ArrowDownWideNarrow,
  ArrowUpNarrowWide,
  Bug,
  Camera,
  Moon,
  Plus,
  Sun
} from 'lucide-react';

import {SquareAltArrowLeftLinearIcon, SquareAltArrowRightLinearIcon} from './iconify';
import {
  BuildingIcon,
  CheckIcon,
  CloseIcon,
  ComplianceIcon,
  InfoIcon,
  KycIcon,
  NotebookIcon,
  TrustDetailsIcon,
  AddBuyerIcon,
  AddListIcon,
  BuyerIcon,
  DocumentIcon,
  InitiatePaymentIcon,
  CelebrationIcon,
  HandBoxIcon,
  PayinIcon,
  PayoutIcon,
  RemoveBuyerIcon,
  SparklesIcon
} from './svgs';

import type {ComponentType, SVGProps} from 'react';

type SvgComponent = ComponentType<SVGProps<SVGSVGElement>>;

export type UntitledIconName =
  | 'alert-circle'
  | 'add'
  | 'arrow-circle-broken-up-right'
  | 'bank-branch'
  | 'coins-hand'
  | 'copy'
  | 'send'
  | 'upload'
  | 'invite-user'
  | 'remove-user'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'bar-chart'
  | 'pie-chart-01'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevrons-updown'
  | 'view'
  | 'delete'
  | 'dots-horizontal'
  | 'dots-vertical'
  | 'edit'
  | 'pen'
  | 'logout'
  | 'shield'
  | 'shield-01'
  | 'switch-horizontal'
  | 'tool'
  | 'save'
  | 'close'
  | 'x-close'
  | 'coins-swap'
  | 'bank-note'
  | 'credit-card-cancel'
  | 'credit-card-check'
  | 'receipt-check'
  | 'ticket'
  | 'credit-card-down'
  | 'credit-card-edit'
  | 'credit-card-expired'
  | 'credit-card-refresh'
  | 'credit-card-up'
  | 'refresh'
  | 'currency'
  | 'file'
  | 'document'
  | 'file-lined'
  | 'grid'
  | 'home'
  | 'inbox'
  | 'line-chart'
  | 'link'
  | 'link-05'
  | 'link-external-02'
  | 'users'
  | 'users-group'
  | 'team'
  | 'user'
  | 'download'
  | 'download-cloud'
  | 'calendar'
  | 'calendar-plus'
  | 'mail'
  | 'check-circle'
  | 'check-circle-dashed'
  | 'clock'
  | 'zap'
  | 'wallet'
  | 'help-circle'
  | 'search'
  | 'search-large'
  | 'settings'
  | 'table'
  | 'filter'
  | 'phone'
  | 'building'
  | 'building-05'
  | 'building-08'
  | 'arrow-narrow-left'
  | 'arrow-narrow-right'
  | 'marker-pin'
  | 'marker-pin-06'
  | 'user-check'
  | 'sort-asc'
  | 'sort-desc'
  | 'hash'
  | 'check'
  | 'globe'
  | 'passport'
  | 'activity'
  | 'bug'
  | 'camera'
  | 'plus'
  | 'sun'
  | 'moon'
  | 'star'
  | 'lock'
  | 'car'
  | 'map'
  | 'route'
  | 'rows'
  | 'menu'
  | 'warehouse'
  | 'house'
  | 'apartment-building'
  | 'bell-ringing-01'
  | 'message-square';

export type IconifyIconName = 'arrow-square-left' | 'arrow-square-right';

export type SollapayIconName =
  | 'sollapay:building'
  | 'sollapay:notebook'
  | 'sollapay:compliance'
  | 'sollapay:kyc'
  | 'sollapay:trust-details'
  | 'sollapay:initiate-payment'
  | 'sollapay:add-buyer'
  | 'sollapay:add-list'
  | 'sollapay:buyer'
  | 'sollapay:document'
  | 'sollapay:celebration'
  | 'sollapay:check'
  | 'sollapay:close'
  | 'sollapay:info'
  | 'sollapay:payin'
  | 'sollapay:payout'
  | 'sollapay:hand-box'
  | 'sollapay:remove-buyer'
  | 'sollapay:sparkles';

export type IconName = UntitledIconName | IconifyIconName | SollapayIconName;

const untitledIconMap: Record<UntitledIconName, SvgComponent> = {
  'alert-circle': AlertCircle,
  add: PlusCircle,
  'arrow-circle-broken-up-right': ArrowCircleBrokenUpRight,
  'bank-branch': Bank,
  'coins-hand': CoinsHand,
  copy: Copy06,
  send: Send01,
  upload: UploadCloud02,
  'invite-user': UserPlus01,
  'remove-user': UserX01,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'bar-chart': BarChart01,
  'pie-chart-01': PieChart01,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevrons-updown': ChevronSelectorVertical,
  view: Eye,
  delete: Trash01,
  'dots-horizontal': DotsHorizontal,
  'dots-vertical': DotsVertical,
  edit: Edit01,
  pen: Pencil01,
  logout: LogOut01,
  shield: ShieldTick,
  'shield-01': Shield01,
  'switch-horizontal': SwitchHorizontal01,
  tool: Tool01,
  save: Save01,
  close: XCircle,
  'x-close': XClose,
  'coins-swap': CoinsSwap01,
  'bank-note': BankNote01,
  'credit-card-cancel': CreditCardX,
  'credit-card-check': CreditCardCheck,
  'receipt-check': ReceiptCheck,
  ticket: Ticket01,
  'credit-card-down': CreditCardDown,
  'credit-card-edit': CreditCardEdit,
  'credit-card-expired': CreditCardMinus,
  'credit-card-refresh': CreditCardRefresh,
  'credit-card-up': CreditCardUp,
  refresh: RefreshCw05,
  currency: CurrencyDollarCircle,
  file: File06,
  document: File01,
  'file-lined': File04,
  grid: Grid01,
  home: Home01,
  inbox: Inbox01,
  'line-chart': LineChartUp02,
  link: Link02,
  'link-05': Link05,
  'link-external-02': LinkExternal02,
  table: Table,
  users: Users03,
  'users-group': Users02,
  team: Users01,
  user: User01,
  download: Download01,
  'download-cloud': DownloadCloud02,
  calendar: Calendar,
  'calendar-plus': CalendarPlus01,
  mail: Mail01,
  passport: Passport,
  'check-circle': CheckCircle,
  'check-circle-dashed': CheckCircleBroken,
  clock: Clock,
  zap: Zap,
  wallet: Wallet03,
  'help-circle': HelpCircle,
  search: SearchMd,
  'search-large': SearchLg,
  settings: Settings01,
  filter: FilterFunnel01,
  phone: Phone01,
  building: Building01,
  'building-05': Building05,
  'building-08': Building08,
  'arrow-narrow-left': ArrowNarrowLeft,
  'arrow-narrow-right': ArrowNarrowRight,
  'marker-pin': MarkerPin03,
  'marker-pin-06': MarkerPin06,
  'user-check': UserCheck01,
  'sort-asc': ArrowUpNarrowWide,
  'sort-desc': ArrowDownWideNarrow,
  bug: Bug,
  camera: Camera,
  plus: Plus,
  hash: Hash01,
  check: Check,
  globe: Globe01,
  activity: Activity,
  sun: Sun,
  moon: Moon,
  star: Star06,
  lock: Lock01,
  car: Car01,
  map: Map02,
  route: Route,
  rows: Rows03,
  menu: Menu01,
  warehouse: Building02,
  // Distinct from `home`, which reads as the nav/dashboard root rather than a dwelling.
  house: Home02,
  'apartment-building': Building04,
  'bell-ringing-01': BellRinging01,
  'message-square': MessageSquare01
};

const iconifyIconMap: Record<IconifyIconName, SvgComponent> = {
  'arrow-square-left': SquareAltArrowLeftLinearIcon,
  'arrow-square-right': SquareAltArrowRightLinearIcon
};

const sollapayIconMap: Record<SollapayIconName, SvgComponent> = {
  'sollapay:building': BuildingIcon,
  'sollapay:notebook': NotebookIcon,
  'sollapay:compliance': ComplianceIcon,
  'sollapay:kyc': KycIcon,
  'sollapay:trust-details': TrustDetailsIcon,
  'sollapay:initiate-payment': InitiatePaymentIcon,
  'sollapay:add-buyer': AddBuyerIcon,
  'sollapay:add-list': AddListIcon,
  'sollapay:buyer': BuyerIcon,
  'sollapay:document': DocumentIcon,
  'sollapay:celebration': CelebrationIcon,
  'sollapay:check': CheckIcon,
  'sollapay:close': CloseIcon,
  'sollapay:info': InfoIcon,
  'sollapay:payin': PayinIcon,
  'sollapay:payout': PayoutIcon,
  'sollapay:hand-box': HandBoxIcon,
  'sollapay:remove-buyer': RemoveBuyerIcon,
  'sollapay:sparkles': SparklesIcon
};

export const iconMap: Record<IconName, SvgComponent> = {
  ...untitledIconMap,
  ...iconifyIconMap,
  ...sollapayIconMap
};
